module.exports = ":host {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 5;\n}\n.progress-value,\n.progress-messages {\n  display: block;\n  position: relative;\n  left: 50%;\n  top: 50%;\n  width: 50px;\n  height: 50px;\n  margin: -30px 0 0 -25px;\n  z-index: 15;\n  background: transparent;\n  border: none;\n  text-align: center;\n  line-height: 50px;\n}\n.progress-messages {\n  margin: 80px auto 0;\n  width: 50%;\n  left: 0;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/splash/splash.component.css
// module id = 475
// module chunks = 0